import { discussions } from "@/mocks/homeContent";

const avatars = [
  "https://readdy.ai/api/search-image?query=minimal%20flat%20avatar%20illustration%20of%20a%20mysterious%20person%20in%20shadow%20with%20a%20red%20scarf%2C%20warm%20ink%20and%20vermillion%20tones%2C%20simple%20geometric%20shape%2C%20editorial%20style&width=240&height=240&seq=ava-1&orientation=squarish",
  "https://readdy.ai/api/search-image?query=minimal%20flat%20avatar%20illustration%20profile%20of%20a%20city%20resident%20in%20warm%20tones%2C%20ink%20and%20brass%20gold%20palette%2C%20simple%20geometric%20editorial%20style&width=240&height=240&seq=ava-2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=minimal%20flat%20avatar%20illustration%20of%20a%20former%20operations%20worker%20with%20glasses%2C%20warm%20red%20and%20charcoal%20tones%2C%20simple%20geometric%20editorial%20style&width=240&height=240&seq=ava-3&orientation=squarish",
  "https://readdy.ai/api/search-image?query=minimal%20flat%20avatar%20illustration%20of%20a%20regular%20reader%20with%20earbuds%2C%20warm%20ink%20and%20gold%20tones%2C%20simple%20geometric%20editorial%20style&width=240&height=240&seq=ava-4&orientation=squarish",
];

export default function DiscussionSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">互动 · 评论氛围</p>
              <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{discussions.topic}</h3>
              <p className="mt-4 max-w-md leading-relaxed text-foreground-600">{discussions.summary}</p>
              <a
                href="#timeline"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
              >
                <i className="ri-chat-smile-3-line" /> 参与本期热议
              </a>
            </div>
          </div>

          <div className="space-y-5 lg:col-span-8">
            {discussions.comments.map((c, i) => (
              <article key={c.text} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center gap-3">
                  <img
                    src={avatars[i % avatars.length]}
                    alt={c.name}
                    className="h-9 w-9 rounded-full object-cover object-top ring-1 ring-background-300"
                  />
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-950">{c.name}</span>
                    {c.tag && (
                      <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-foreground-950">
                        <i className="ri-thumb-up-fill text-xs" /> {c.tag}
                      </span>
                    )}
                  </div>
                  <span className="ml-auto flex items-center gap-1 text-xs text-accent-700">
                    <i className="ri-thumb-up-fill" /> {c.agree.toLocaleString()} 人认同
                  </span>
                </div>
                <p className="mt-4 text-[15px] leading-relaxed text-foreground-700">{c.text}</p>
                <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-thumb-up-line" />认同</span>
                  <span className="flex items-center gap-1"><i className="ri-reply-line" />回复</span>
                  <span className="flex items-center gap-1"><i className="ri-flag-line" />举报</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}